import request from "./request";
const rootPath =
  process.env.NODE_ENV === "development"
    ? "/api"
    : "https://language.phenxie.com/api";
export function mmseList(pageNum, pageSize, params ) {
  return request({
    url:
      rootPath +
      `/examine/mmse/listpage?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "post",
    data: params,
  });
}
export function addmmse(params) {
  return request({
    url: rootPath + `/examine/mmse/add`,
    method: "post",
    data: params,
  });
}
export function deletemmse(id) {
  return request({
    url: rootPath + `/examine/mmse/remove?id=${id}`,
    method: "post",
    data: {},
  });
}
export function updatemmse(params) {
  return request({
    url: rootPath + `/examine/mmse/update`,
    method: "post",
    data: params,
  });
}
export function getmmseDetail(id) {
  return request({
    url: rootPath + `/examine/mmse/${id}`,
    method: "get",
    params: {},
  });
}
export function uploadFile(params) {
  return request({
    url: rootPath + `/examine/uploadAudio`,
    method: "post",
    data: params,
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });
}
export function uploadImages(params) {
  return request({
    url: rootPath + `/examine/uploadImage`,
    method: "post",
    data: params,
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });
}
